import { render } from "./Builder.vue?vue&type=template&id=42e823c4&scoped=true"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"

import "./Builder.vue?vue&type=style&index=0&id=42e823c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e823c4"]])

export default __exports__